



































































































































































































































































import { Component, Mixins, Watch } from 'vue-property-decorator';
import UserMethods from '@/mixins/UserMethods.vue';
import { mapActions } from 'vuex';
import { Actions, Mutations } from '@/ts/store/Constants';
import ExpandTransition from '@/components/DropDowns/ExpandTransition.vue';
import Tooltip from '@/components/Dialogs/Tooltip.vue';
import RouterMethods from '@/mixins/RouterMethods.vue';

@Component({
    components: {
        ExpandTransition,
        Tooltip,
    },
    methods: {
        ...mapActions({
            logOut: Actions.LOG_OUT,
        }),
    },
})
export default class Aside extends Mixins(UserMethods, RouterMethods) {
    // TODO: by Albert. userHasAccessTo('finances-management') - this is correct check for finances management (replace all 'false' tabs to this)

    public activeMenuDropDown: string = '';
    public messageUsTooltipVisibility: boolean = false;
    public helpTooltipVisibility: boolean = false;
    public translationsTooltipVisibility: boolean = false;

    constructor() {
        super();
    }

    get user() {
        return this.$store.getters['User/getUser'];
    }

    @Watch('$route')
    public routeChanged() {
        this.checkForInitialDropDown();
    }

    public openMenuDropDown(menuDropDown: string) {
        if (menuDropDown === this.activeMenuDropDown) {
            this.activeMenuDropDown = '';
            return;
        }

        this.activeMenuDropDown = menuDropDown;
    }

    public userHasAccessTo(feature: string) {
        if (this.$store.getters['User/getUser'] === null) {
            return false;
        }

        return this.$store.getters['User/getUser'].hasAccessTo(feature);
    }

    public uploadTranslations() {
        this.$store.dispatch(Actions.SEND_MISSING_TRANSLATIONS);
    }

    public contactUsModal() {
        this.$store.commit(Mutations.SET_CONTACT_US_VISIBILITY, true);
    }

    public openLiveAgent() {
      this.$liveAgentButton.onClick();
    }

    public checkForInitialDropDown() {
        let dropDownParent = '';

        if (this.isProjectRoutes) {
            dropDownParent = 'project-list';
        }

        if (this.isAdministrationRoutes) {
            dropDownParent = 'administration';
        }

        if (this.isWaitingListRoutes) {
            dropDownParent = 'waiting-list';
        }

        if (this.isHelpDeskRoutes) {
            dropDownParent = 'ticket-list';
        }

        if (dropDownParent !== this.activeMenuDropDown) {
            this.openMenuDropDown(dropDownParent);
        }
    }

    public created() {
        this.checkForInitialDropDown();
    }
}
